<template>
  <!-- 
    功能测试页面 功能测试页面 
    功能测试页面 功能测试页面 
    功能测试页面 功能测试页面 
    功能测试页面 功能测试页面 
    功能测试页面 功能测试页面 
    功能测试页面 功能测试页面 
    功能测试页面 功能测试页面 
  -->
  <div class="testPage">
      我只是一个测试页,外部无法访问！
  </div>
</template>

<script>
import '../js/flexible.debug.js'
import global from "../js/global.js"
export default {
  data () {
    return {
      popShow:false,
    }
  },
  created(){
  },
  methods:{
    toStore(){
      this.popShow = global.toStore()
    },
    closeTip(){
      this.popShow = false;
    }
  }
}
</script>

<style scoped lang="less">
.testPage{
  position: relative;
  font-size: 80px;
  padding: 30px;
}
</style>



// WEBPACK FOOTER //
// src/share/shareTestPage.vue